// extracted by mini-css-extract-plugin
export default {"login":"Login_login__7HTpy","login_":"Login_login___VAkKY","brand":"Login_brand__MbxV2","login_form":"Login_login_form__-9uEI"};